// @flow
import {
    MIGRATION_STATUS_REQUEST,
    MIGRATION_STATUS_RESPONSE,
    START_MIGRATION_POLL,
    START_MIGRATION_REQUEST,
    START_MIGRATION_RESPONSE,
    STOP_MIGRATION_POLL,
    PROGRESS_INSTALL_STAGE
} from './constants';

import { createAction } from 'redux-actions';

export const migrationStatusRequest = createAction(MIGRATION_STATUS_REQUEST);
export const migrationStatusResponse = createAction(MIGRATION_STATUS_RESPONSE);
export const startMigrationRequest = createAction(START_MIGRATION_REQUEST);
export const startMigrationResponse = createAction(START_MIGRATION_RESPONSE);
export const startMigrationPoll = createAction(START_MIGRATION_POLL);
export const stopMigrationPoll = createAction(STOP_MIGRATION_POLL);
export const progressInstallStage = createAction(PROGRESS_INSTALL_STAGE);



// WEBPACK FOOTER //
// ./src/core/state/install-nano1-upgrade/actions.js